import React, { Fragment, useState } from "react";
import { Field, reduxForm } from "redux-form";
import { renderField } from "Utils/renderField/renderField";
import NumberFormat from "react-number-format";

const required = (value) => (value ? undefined : "Campo requerido.");

const Form = (props) => {
    const { handleSubmit, disabled  } = props;

    // Estado local del switch
    const [mostrarDespacho, setMostrarDespacho] = useState(false);


    console.log("EL ESTADO DE disabled ES: ", disabled);

    return (
        <form onSubmit={handleSubmit} className="mt1">
            <div className="row">

                {/* SWITCH */}
                <div
                    className="col-md-12 form-group d-flex align-items-center pb-2"
                    style={{ borderBottom: "3px solid #7e7e7eff" }}
                >
                    <label className="switch mb-0">
                        <Field
                            name="usa_despacho"
                            component="input"
                            type="checkbox"
                            onChange={(e) => setMostrarDespacho(e.target.checked)}
                            disabled={disabled}
                        />
                        <span className="slider round" />
                    </label>

                    <label htmlFor="usa_despacho" className="ml-2 mb-0">
                        GENERAR DESPACHO
                    </label>
                </div>

                

                {/* FORMULARIO QUE SE MOSTRARÁ CUANDO EL SWITCH ESTÉ ACTIVADO */}
                {mostrarDespacho && (
                    <Fragment>
                        <div className="col-lg-6 col-md-6 col-sm-12 form-group">
                            <label htmlFor="direccion_entrega">Dirección de entrega</label>
                            <Field
                                name="direccion_entrega"
                                component={renderField}
                                type="text"
                                validate={[required]}
                                className="form-control"
                                label="Ingrese la dirección de entrega de la orden"
                                disabled={disabled}
                            />
                        </div>

                        <div className="col-lg-6 col-md-6 col-sm-12 form-group">
                            <label htmlFor="nombre_tienda">Recibido por</label>
                            <Field
                                name="nombre_recibido_por"
                                label="Nombre de quien recibe"
                                component={renderField}
                                type="text"
                                validate={[required]}
                                placeholder="Nombre de quien recibe"
                                className="form-control"
                                disabled={disabled}
                            />
                        </div>

                        <div className="col-lg-6 col-md-6 col-sm-12 form-group">
                            <label htmlFor="nombre_encargado">Nombre del encargado</label>
                            <Field
                                name="nombre_encargado"
                                label="Nombre del encargado del despacho"
                                component={renderField}
                                type="text"
                                validate={[required]}
                                className="form-control"
                                disabled={disabled}
                            />
                        </div>

                        <div className="col-lg-6 col-md-6 col-sm-12 form-group">
                            <label htmlFor="telefono_encargado">Teléfono del encargado</label>
                            <Field
                                name="telefono_encargado"
                                component={renderField}
                                type="text"
                                validate={[required]}
                                className="form-control"
                                placeholder="Ingrese el número de teléfono"
                                disabled={disabled}
                            />
                        </div>

                        <div className="col-lg-12 col-md-12 col-sm-12 form-group">
                            <label htmlFor="notas_adicionales">Notas adicionales</label>
                            <Field
                                name="notas_adicionales"
                                component="textarea"
                                className="form-control"
                                rows="3"
                                placeholder="Ingrese notas adicionales si es necesario"
                                disabled={disabled}
                            />
                        </div>

                        
                    </Fragment>
                )}
            </div>
        </form>
    );
};

export default reduxForm({
    form: "DespachosForm",
})(Form);